export interface IDashMonitoringCount {
    monitorDate: string,
    monitorDateForDisplay: string,
    micrositeCount: number,
    nkrDashCount: number,
    plDashCount: number
}